<template>
  <div>
    <div class="row">
        <div class="col-sm-12">
            <div class="page-title-box">
                <div class="float-right">
                    <ol class="breadcrumb">
                    <li class="breadcrumb-item"><a href="javascript:void(0);">BPD BALI</a></li>
                    <li class="breadcrumb-item active">Pengguna</li>
                    <li class="breadcrumb-item active">{{ $route.name == 'instanceUserCreate' ? 'Tambah' : 'Edit' }}</li>
                    </ol>
                </div>
                
                <h4 class="page-title">
                    <router-link :to="{ name: 'instanceUser' }">
                        <i class="fas fa-arrow-left mr-2"></i>
                    </router-link>
                    Pengguna
                </h4>
            </div>
        </div>
    </div>

    <div>
        <form @submit.prevent="submitForm()" autocomplete="off">
             <div class="card">
                <div class="card-body">
                    <div class="form-group" :class="{ 'is-invalid': $v.dataUser.role_id.$error }">
                        <label for="select-2-form" class="col-form-label text-left d-block">Role</label>
                        <select v-model="$v.dataUser.role_id.$model" class="form-control" :disabled="dataUser.role_id == 'COMPANY_SUPERADMIN'"
                            v-if="dataUser.role_id == 'COMPANY_SUPERADMIN'">
                            <option value="COMPANY_SUPERADMIN">Super Admin Instansi</option>
                        </select>

                        <div v-else>
                            <select v-model="$v.dataUser.role_id.$model" class="form-control" 
                                v-if="companyType == 'OTHER'"
                                :disabled="dataUser.role_id == 'COMPANY_SUPERADMIN'">
                                <option value="ADMIN">Admin</option>
                                <option value="PETUGAS">Petugas</option>
                                <option value="ADMIN_APPROVER">Admin Releaser</option>
                                <option value="ADMIN_MAKER">Admin Maker</option>
                            </select>

                            <select v-model="$v.dataUser.role_id.$model" class="form-control" :disabled="dataUser.role_id == 'COMPANY_SUPERADMIN'"
                                v-if="companyType == 'HEALTH_CARE'">
                                <option value="HEALTH_CARE_ADMIN">Admin</option>
                                <option value="HEALTH_CARE_EXECUTIVE">Eksekutif</option>
                                <option value="HEALTH_CARE_LOCKET_&_CASHIER">Loket & Kasir</option>
                                <option value="HEALTH_CARE_LOCKET">Loket</option>
                                <option value="HEALTH_CARE_CASHIER">Kasir</option>
                            </select>
                        </div>
                        <div class="error" v-if="!$v.dataUser.role_id.required">Role wajib diisi</div>
                    </div>

                    <div class="form-group" :class="{ 'is-invalid': $v.dataUser.name.$error }">
                        <label for="select-2-form" class="col-form-label text-left d-block">Nama</label>
                        <input type="text" class="form-control" placeholder="Masukkan Nama" 
                        v-model.trim="$v.dataUser.name.$model"
                        :disabled="loading">
                        <div class="error" v-if="!$v.dataUser.name.required">Nama wajib diisi</div>
                    </div>

                    <div class="form-group" :class="{ 'is-invalid': $v.dataUser.username.$error }">
                        <label for="select-2-form" class="col-form-label text-left d-block">Username</label>
                        <input type="text" class="form-control" placeholder="Masukkan Username" 
                        v-model.trim="$v.dataUser.username.$model"
                        :disabled="loading">
                        <div class="error" v-if="!$v.dataUser.username.required">Username wajib diisi</div>
                        <div class="error" v-if="!$v.dataUser.username.username">Username tidak boleh berisi spasi atau simbol</div>
                    </div>

                    <div class="form-check form-group" v-if="this.$route.name == 'instanceUserEdit'">>
                        <input class="form-check-input" type="checkbox" v-model="is_password_edit" id="defaultCheck1">
                        <label class="form-check-label" for="defaultCheck1" style="margin-top: 1px;">
                            Apakah anda ingin mengedit password ?
                        </label>
                    </div>

                    <div v-if="is_password_edit">
                        <div class="form-group" :class="{ 'is-invalid': $v.dataUser.password.$error }">
                            <label for="select-2-form" class="col-form-label text-left d-block">Kata Sandi</label>
                            <input type="password" class="form-control" placeholder="Masukkan Kata Sandi" 
                            v-model.trim="$v.dataUser.password.$model"
                            :disabled="loading">
                            <div class="error" v-if="!$v.dataUser.password.required">Kata Sandi wajib diisi</div>
                            <div class="error" v-if="!$v.dataUser.password.password">Kata Sandi harus terdiri dari minimal 8 karakter huruf besar, huruf kecil, angka dan symbol. karakter </div>
                        </div>

                        <div class="form-group" :class="{ 'is-invalid': $v.dataUser.password_confirmation.$error }">
                            <label for="select-2-form" class="col-form-label text-left d-block">Konfirmasi Kata Sandi</label>
                            <input type="password" class="form-control" placeholder="Masukkan Konfirmasi Kata Sandi" 
                            v-model.trim="$v.dataUser.password_confirmation.$model"
                            :disabled="loading">
                            <div class="error" v-if="!$v.dataUser.password_confirmation.required">Konfirmasi kata sandi wajib diisi</div>
                            <div class="error" v-if="!$v.dataUser.password_confirmation.sameAs">Konfirmasi kata sandi harus sama dengan form diatas</div>
                            <div class="error" v-if="!$v.dataUser.password_confirmation.password">Konfirmasi kata Sandi harus terdiri dari minimal 8 karakter huruf besar, huruf kecil, angka dan symbol. karakter </div>
                        </div>
                    </div>

                </div>
            </div>


            <button class="btn btn-success waves-effect waves-light mb-5" :disabled="loading">
                Simpan Pengguna
                <div class="spinner-border text-light ml-2" role="status" v-if="loading">
                    <span class="sr-only">Loading...</span>
                </div>
            </button>

            <br>
        </form>
    </div>

  </div>
</template>

<script>
    import Swal from 'sweetalert2'
    import { required, sameAs, minLength, helpers } from 'vuelidate/lib/validators'
    const username = helpers.regex('username', /^[a-z0-9_]*$/)
    const passwordRegex = helpers.regex('password', /^(?=.*[!@#$%^&*-])(?=.*[0-9])(?=.*[A-Z]).{8,20}$/)

    export default {
        data() {
            return {
                loading: false,
                is_password_edit: this.$route.name == 'instanceUserEdit' ? false : true,
                dataUser: {
                    role_id: 'ADMIN',
                    name: '',
                    username: '',
                    password: '',
                    password_confirmation: '',
                },
            };
        },
        validations() {
            if(!this.is_password_edit && this.$route.name == 'instanceUserEdit') {
                return {
                    dataUser: {
                        role_id: {
                            required,
                        },
                        name: {
                            required,
                        },
                        username: {
                            required,
                            username
                        }
                    }
                }
            }else{
                return {
                    dataUser: {
                        role_id: {
                            required,
                        },
                        name: {
                            required,
                        },
                        username: {
                            required,
                            username
                        },
                        password: {
                            passwordRegex,
                            required
                        },
                        password_confirmation: {
                            passwordRegex,
                            required,
                            sameAsPassword: sameAs('password')
                        }
                    }
                }
            }
        },
        methods: {
            // SUBMIT FORM
            submitForm() {
                // IF VALIDATION INVALID
                if (this.$v.dataUser.$invalid) {
                    this.$v.$touch()
                    this.sAlert('error', 'Harap isi semua form dengan benar!')
                    return
                }

                this.loading = true

                let url, method, alertSuccess, storedData
                if(this.$route.name == 'instanceUserCreate') {
                    url = `company/user/store`
                    method = 'POST',
                    alertSuccess = 'Berhasil membuat pengguna baru!'
                    storedData = {
                        role_id: this.dataUser.role_id,
                        name: this.dataUser.name,
                        name: this.dataUser.name,
                        username: this.dataUser.username,
                        password: this.dataUser.password,
                        password_confirmation: this.dataUser.password_confirmation
                    }
                }else{
                    url = `company/user/update/${this.$route.params.id}`
                    method = 'POST',
                    alertSuccess = 'Berhasil mengupdate pengguna!'
                    if(this.is_password_edit){
                        storedData = {
                            role_id: this.dataUser.role_id,
                            name: this.dataUser.name,
                            username: this.dataUser.username,
                            password: this.is_password_edit ? this.dataUser.password : null,
                            password_confirmation: this.is_password_edit ? this.dataUser.password_confirmation : null
                        }
                    }else{
                        storedData = {
                            role_id: this.dataUser.role_id,
                            name: this.dataUser.name,
                            username: this.dataUser.username
                        }
                    }
                    
                }

                this.$http({
                    method,
                    url: `${this.API_URL}${url}`,
                    data: storedData,
                    headers: { 'Authorization': `Bearer ${this.$cookies.get("token_instance")}` }
                })
                .then(response => {
                    const result = response.data;
                    
                    if(result.success) {
                        this.sAlert('success', alertSuccess)
                        this.$router.push({ name: 'instanceUser' });
                    }else {
                        this.sAlert('error', result.message)
                    }
                    
                    this.loading = false;
                })
                .catch(error => {
                    this.loading = false;
                    this.sAlert('error', "Error, Terjadi Kesalahan!")
                    this.sAlert('error', error.response.data.message)
                });
            }
        },
        mounted() {
            // LOAD DATA IF ROUTE IS EDIT
            if(this.$route.name == 'instanceUserEdit'){
                this.loadingInitial = true
                // LOAD DATA
                this.$http.get(`${this.API_URL}company/user/show/${this.$route.params.id}`, {
                    headers: { 'Authorization': `Bearer ${this.$cookies.get("token_instance")}` }
                })
                .then(response => {
                    this.loadingInitial = false

                    const result = response.data;
                    let role
                    if(result.data.role_name == "COMPANY SUPERADMIN"){
                        role = 'COMPANY_SUPERADMIN'
                    }else if(result.data.role_name == "COMPANY ADMIN"){
                        role = 'ADMIN'
                    }else if(result.data.role_name == "COMPANY OPERATOR"){
                        role = 'OPERATOR'
                    }else if(result.data.role_name == "COMPANY ADMIN APPROVER"){
                        role = 'ADMIN_APPROVER'
                    }else if(result.data.role_name == "ADMIN MAKER"){
                        role = 'ADMIN_MAKER'
                    }
                    
                    // HEALTHCARE
                    else if(result.data.role_name == "HEALTH CARE ADMIN"){
                        role = 'HEALTH_CARE_ADMIN'
                    }else if(result.data.role_name == "HEALTH CARE EXECUTIVE"){
                        role = 'HEALTH_CARE_EXECUTIVE'
                    }else if(result.data.role_name == "HEALTH CARE LOCKET & CASHIER"){
                        role = 'HEALTH_CARE_LOCKET_&_CASHIER'
                    }else if(result.data.role_name == "HEALTH CARE LOCKET"){
                        role = 'HEALTH_CARE_LOCKET'
                    }else if(result.data.role_name == "HEALTH CARE CASHIER"){
                        role = 'HEALTH_CARE_CASHIER'
                    }

                    if(result.success) {
                        this.dataUser.role_id = role
                        this.dataUser.name = result.data.name
                        this.dataUser.username = result.data.username
                    }else {
                        this.sAlert('error', result.message)
                    }

                    this.loading = false;
                })
                .catch(error => {
                    this.loadingInitial = false;
                    this.sAlert('error', "Error, Terjadi Kesalahan!")
                });
            }
        }
    }
</script>
